<template>
	<div>
		<!-- 顶部显示的页面 -->
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
			<el-breadcrumb-item>明信片管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 新增套餐的按钮 -->
		<div>
			<el-button type="primary" @click="protocol(1)">隐私政策</el-button>
			<el-button type="primary" @click="protocol(2)">用户协议</el-button>
			<el-button type="primary" @click="settingExpress">运费设置</el-button>
			<el-button type="primary" @click="order">订单管理</el-button>
			<el-button type="primary" @click="add">新增商品</el-button>
			<el-button type="primary" @click="copy">复制小程序明信片地址</el-button>
		</div>
		<el-input class="wxSrcHide" ref="wxSrc" value="pages/postcard/postcard" readonly></el-input>
		<div style="margin-top:20px">
			<el-table :data="list">
				<el-table-column label="ID" width="100" prop="id"/>
				<el-table-column label="商品名称" prop="name"/>
				<el-table-column label="宽高比" prop="" width="160">
					<template slot-scope="scope">
						<el-tag>{{ scope.row.photo_width }}/{{ scope.row.photo_height }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="价格（元）" prop="retail_price" width="120"/>
				<el-table-column label="上架状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.is_on_sale?'success':'warning'">
							{{ scope.row.is_on_sale ? '已上架' : '未上架' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="创建日期" width="160" prop="add_time"/>
				<el-table-column label="操作" width="240">
					<template slot-scope="scope">
						<el-button size="mini" :type="scope.row.is_on_sale?'warning':'success'"
								   @click="changeShelf(scope.row)">
							{{ scope.row.is_on_sale ? '下' : '上' }}架
						</el-button>
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 分页 -->
		<div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						   :current-page="queryList.pageindex" :page-sizes="[10, 20, 30, 40]"
						   :page-size="queryList.pagesize"
						   layout="total,  prev, pager, next, jumper"
						   :total="total"
						   style="text-align:right;margin:0 16px 10px 0;border-radius:20px"></el-pagination>
		</div>
		<el-dialog title="系统设置" :visible.sync="dialogExpress" width="500px">
			<el-form :model="express" label-width="210px">
				<el-form-item label="运费满减不足所需运费（元）：" prop="express_price">
					<el-input-number style="width: 200px;" v-model.number="express.express_price" :precision="2"
									 :min="0" :step="1"></el-input-number>
				</el-form-item>
				<el-form-item label="运费满减所需最低消费（元）：" prop="express_free_limit">
					<el-input-number style="width: 200px;" v-model.number="express.express_free_limit" :precision="2"
									 :min="0" :step="1"></el-input-number>
				</el-form-item>
				<el-form-item label="用户首次免费张数：" prop="free_num">
					<el-input-number v-model.number="express.free_num" :precision="0"
									 :min="0" :step="1"></el-input-number>
				</el-form-item>
				<el-form-item label="明信片入口文字：" prop="enter_word">
					<el-input style="width: 200px;" v-model="express.enter_word"></el-input>
				</el-form-item>
				<el-form-item label="公众号引导语：" prop="public_word">
					<el-input style="width: 200px;" v-model.trim="express.public_word"
							  placeholder="请输入公众号引导"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogExpress = false">取 消</el-button>
				<el-button type="primary" @click="editExpress">确 定</el-button>
		    </span>
		</el-dialog>
	</div>
</template>

<script>
import api from "../../api/card";

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			currentPage: 1,   //分页
			total: 0,        //分页
			list: [],
			queryList: {
				pageindex: 1,
				pagesize: 10,
				orderby: undefined,
				count: true
			},
			dialogExpress: false,
			express: {
				express_price: 0,
				express_free_limit: 0,
				free_num: 0,
				enter_word: '',
				public_word: ''
			},//运费
			originalExpress: {}
		}
	},
	mounted() {
		this.getList();
		this.getExpress();
	},
	methods: {
		getList() {
			api.postcardList(this.queryList).then(res => {
				this.list = res.list;
				this.total = res.totalcount;
			})
		},
		order() {
			this.$router.push({
				path: "/cardOrder"
			});
		},
		add() {
			this.$router.push({
				path: "/postcard",
				query: {type: 0}
			});
		},
		copy() {//复制
			let textarea = this.$refs.wxSrc;
			textarea.select();
			document.execCommand('Copy');
			this.$message({
				type: 'success',
				showClose: true,
				message: '操作成功!'
			});
		},
		protocol(type) {
			if (type === 1) {
				this.$datas.protocol = this.originalExpress.user_private;
			} else this.$datas.protocol = this.originalExpress.user_agree;
			this.$router.push({
				path: "/protocol",
				query: {type}
			});
		},
		settingExpress() {
			this.express = Object.assign({}, this.originalExpress);
			this.dialogExpress = true;
		},
		getExpress() {
			api.getExpress().then(res => {
				this.originalExpress = res;
			})
		},
		editExpress() {
			api.updateExpress(this.express).then(res => {
				this.dialogExpress = false;
				this.getExpress();
			}).catch(err => {
				this.$message({
					type: 'error',
					message: err.msg
				});
			})
		},
		changeShelf(row) {
			let is_on_sale = row.is_on_sale ? 0 : 1;
			api.updatePostcard({id: row.id, is_on_sale}).then(res => {
				this.$message({
					type: 'success',
					showClose: true,
					message: '操作成功!'
				});
				this.getList();
			}).catch(err => {
				this.$message({
					type: 'error',
					message: err.msg || '操作失败！'
				});
			})
		},
		edit(row) {// 用户编辑
			row.gallery = JSON.parse(row.gallery).map(v => {
				return {url: v}
			});
			this.$datas.postcard = row;
			this.$router.push({
				path: "/postcard",
				query: {type: 1}
			});
		},
		del(row) {//删除
			let id = row.id;
			this.$confirm('确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				api.deletePostcard({id}).then(res => {
					this.$message({
						type: 'success',
						showClose: true,
						message: '删除成功!'
					});
					this.getList();
				})
			})
		},
		// 分页
		handleSizeChange(val) {
			this.queryList.pagesize = val;
			this.findScenicSpot();
		},
		handleCurrentChange(val) {
			this.queryList.pageindex = val;
			this.findScenicSpot();
		},
	},
}
</script>

<style>
.wxSrcHide {
	position: fixed;
	top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/card/list.vue